import { Grid, TextField, Button, Typography, Alert, Box } from "@mui/material";
import { useEffect, useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase/firebase";
import { useNavigate } from "react-router-dom";

const Seccion_Login = () => {

    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    // ✅ useEffect para mover el scroll al inicio
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");

        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate("/dashboard"); // redirigir al dashboard
        } catch (err) {
            console.error(err);
            if (err.code === "auth/user-not-found") {
                setError("Usuario no encontrado");
            } else if (err.code === "auth/wrong-password") {
                setError("Contraseña incorrecta");
            } else {
                setError("Error al iniciar sesión");
            }
        }
    };

    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{ minHeight: "100vh", backgroundColor: "#f5f5f5", p: 3 }}
        >
            <Grid
                item
                xs={12}
                sm={8}
                md={4}
                sx={{
                    backgroundColor: "#fff",
                    p: 4,
                    borderRadius: 2,
                    boxShadow: 3
                }}
            >
                <form onSubmit={handleLogin}>
                    <Typography variant="h5" align="center" gutterBottom>
                        Iniciar Sesión
                    </Typography>

                    {error && (
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {error}
                        </Alert>
                    )}

                    <TextField
                        label="Correo electrónico"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        fullWidth
                        required
                        margin="normal"
                    />

                    <TextField
                        label="Contraseña"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        fullWidth
                        required
                        margin="normal"
                    />

                    <Box mt={2}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            fullWidth
                        >
                            Entrar
                        </Button>
                    </Box>
                </form>
            </Grid>
        </Grid>
    );
};

export default Seccion_Login;
